<template>
    <div class="main_wrap">
        <div class="blockBox blockBox_form top_border_blue bc_white shadow mt_20">
            <!-- 表单部分 -->
            <el-form
                class="formBox"
                label-position="right"
                label-width="1.1rem"
                label-suffix="："
                :model="form"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="开工时间">
                            <TimeSelect
                                :timeList="timeList"
                                :diyTimeProp="[form.sLandStartTime,form.sLandStopTime]"
                                @selectTime="selectTime"
                            ></TimeSelect>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="销售状态">
                            <MultipleSelect
                                value-type="label"
                                paramKey="SaleState"
                                :selection="staticEnum.saleStatus"
                                @selectOption="selectOption"
                            ></MultipleSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属城市">
                                    <!-- <CitySearch :city="form.sCity" @chooseCity="chooseCity"></CitySearch> -->
                                    <MultipleSelectDiy
                                        :options="cityData"
                                        :defaultVal="defaultCity"
                                        placeholderWrap="不限"
                                        :placeholderData="['搜索省份','搜索城市']"
                                        :hasCheckAll="true"
                                        @valueChange="valChange"
                                        @clearAll="clearAll"
                                        @delFirstItem="delFirst"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="房企">
                                    <!-- <CompanySearch :company="form.sCompanyType" @searchCompany="searchCompany"></CompanySearch> -->
                                    <CompanySearchNew
                                        :companyList="companyList"
                                        :companyData="companyDefaultObj"
                                        @submitCheck="checkCompany"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-row>
                            <el-form-item label="物业类型">
                                <MultipleSelect
                                    value-type="label"
                                    paramKey="HomeType"
                                    :selection="staticEnum.propertyType"
                                    @selectOption="selectOption"
                                ></MultipleSelect>
                            </el-form-item>
                        </el-row>
                    </el-col>
                    <el-col :span="7">
                        <el-row>
                            <el-form-item label="装修情况">
                                <MultipleSelect
                                    value-type="label"
                                    paramKey="Fitment"
                                    :selection="staticEnum.decorationType"
                                    @selectOption="selectOption"
                                ></MultipleSelect>
                            </el-form-item>
                        </el-row>
                    </el-col>
                </el-row>
            </el-form>

            <!-- 表单展示（charts） -->
            <div class="formShow_chart">
                <div class="showDetail">
                    <ul class="innerBox">
                        <li
                            class="item"
                            v-for="(item,index) in chartListData.aTakeHomeCount"
                            :key="index"
                        >
                            <p class="value">{{item.value}}</p>
                            <p class="label">{{item.label}}</p>
                        </li>
                    </ul>
                </div>
                <div class="showChart flex_justify_around">
                    <div class="w_40 h_100">
                        <Echarts :options="getOptions('pie',pieChartsData)"></Echarts>
                    </div>
                    <div class="w_45 h_100">
                        <Echarts :options="getOptions('base',lineBarChartsData)"></Echarts>
                    </div>
                </div>
            </div>
        </div>
        <div class="formShow_table">
            <div class="blockHead flex_justify_between mt_20">
                <p class="blockTitle">
                    <span class="name">房企项目最新开工</span>
                    <span class="split">|</span>
                    <span class="value">共{{total}}条数据</span>
                </p>
                <div class="searchBox flex_align">
                    <Search placeholder="请输入项目名称、城市、开发商、开发商简称关键字搜索" @handleIconClick="search"></Search>
                    <BaseExport module="project" @exportData="exportData" />
                </div>
            </div>
            <div class="blockBox bc_white shadow">
                <TableList :tableObj="tableObj" :type="2" :module="2"></TableList>
            </div>
            <!-- 分页器 -->
            <Pagination
                :total="total"
                :current="currentPage"
                :pageSize="pageSize"
                @pageChange="pageChange"
            ></Pagination>
        </div>
    </div>
</template>
<script>
import Echarts from '@/components/Echarts'
import getCharts from '@/utils/getCharts.js'
import chartSet from '@/config/chartSet'
import staticEnum from '@/utils/staticEnum'
import ajaxService from '@/server/api.js'
import listCommonMixin from '@/mixins/listCommon.js'
export default {
    mixins: [listCommonMixin],
    data() {
        return {
            staticEnum,
            timeList: staticEnum.timeList.slice(1, 5),
            form: {
                //用于图表传参
                iTimeType: staticEnum.timeList.slice(1, 5)[0].value, //时间类型
                sLandStartTime: '', //自定义开始时间
                sLandStopTime: '', //自定义结束时间
                sCity: '', //城市
                sCompanyType: '', //公司
                SaleState: [], //销售状态
                HomeType: [], //物业类型
                Fitment: [] //装修情况
            },
            sKeyword: '', //搜索关键字
            currentPage: 1, //当前页数
            total: 0, //表格列表总条数
            pageSize: 0, //表格列表单页条数
            chartListData: {}, //图表部分数据
            tableObj: {
                //表格数据
                tableHead: [
                    {
                        prop: 'Caption',
                        label: '项目名称',
                        align: 'left',
                        width: 200
                    },
                    {
                        prop: 'CityCaption',
                        label: '城市',
                        align: 'center',
                        width: 60
                    },
                    {
                        prop: 'TotalBuildArea',
                        label: '总建面积(㎡)',
                        align: 'center',
                        width: 100
                    },
                    {
                        prop: 'HomeType',
                        label: '项目属性',
                        align: 'center'
                    },
                    {
                        prop: 'Fitment',
                        label: '装修情况',
                        align: 'center'
                    },
                    {
                        prop: 'Developer',
                        label: '开发商',
                        align: 'center',
                        width: 200
                    },
                    {
                        prop: 'BuildTime',
                        label: '开工时间',
                        align: 'center'
                    }
                ],
                tableData: []
            }
        }
    },
    components: {
        Echarts
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                this.currentPage = 1
                this.initData()
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        tableParam() {
            //表格列表的参数
            let temp = {
                LandCaption: this.sKeyword, //搜索关键字
                iPage: this.currentPage //页码
            }
            return { ...this.form, ...temp }
        },
        pieChartsData() {
            let obj = {
                title: '物业类型\n占比',
                data: this.chartListData.TypePro
            }
            return chartSet.listPieCharts(obj)
        },
        lineBarChartsData() {
            let obj = {
                title: '开工面积、开工项目趋势',
                xAxisData: [],
                series: [
                    {
                        type: 'bar',
                        name: '开工面积',
                        data: [],
                        unit: '万㎡'
                    },
                    {
                        type: 'line',
                        name: '开工项目个数',
                        data: [],
                        unit: '个'
                    }
                ]
            }
            if (this.chartListData.aDataCountChart && this.chartListData.aDataCountChart.length) {
                this.chartListData.aDataCountChart.forEach((item) => {
                    obj.xAxisData.push(item.sCateDesc)
                    obj.series[0].data.push(item.Area)
                    obj.series[1].data.push(item.iCnt)
                })
            }
            return chartSet.listLineBarCharts(obj)
        }
    },
    created() {
        // this.initRouter()
        // this.initData()
        document.title = '房企项目开工监控系统 - 优采大数据'
    },
    methods: {
        initRouter() {
            // console.log(this.$route.query)
            if (this.$route.query.startDate && this.$route.query.endDate) {
                this.form.sLandStartTime = this.$route.query.startDate
                this.form.sLandStopTime = this.$route.query.endDate
            }
            if (this.$route.query.type && this.$route.query.name) {
                switch (this.$route.query.type) {
                    case 'company':
                        this.form.sCompanyType = this.$route.query.name
                        this.setCompanyByDefaultVal(this.$route.query.name)
                        break
                    case 'city':
                        this.form.sCity = this.$route.query.name
                        this.setCityByDefaultCity(this.$route.query.name)
                        break
                }
            }
        },
        // 初始化数据
        initData() {
            this.getChartData(this.form) //图表数据
            this.getListData(this.tableParam) //表格数据
        },
        // 选择时间
        selectTime(val) {
            console.log('选择时间', val)
            this.form.iTimeType = val.activeTime
            if (this.form.iTimeType == 4) {
                this.form.sLandStartTime = val.diyTime[0]
                this.form.sLandStopTime = val.diyTime[1]
            }
        },
        // 多选
        selectOption(obj) {
            console.log('选择了', obj)
            this.form[obj.key] = obj.data
        },
        // 城市选择
        chooseCity(city) {
            console.log('城市选择', city)
            this.form.sCity = city
        },
        // 房企选择
        searchCompany(val) {
            console.log('房企选择', val)
            this.form.sCompanyType = val
        },
        // 搜索
        search(key) {
            console.log('搜索', key)
            this.sKeyword = key
            this.getListData(this.tableParam)
        },
        // page页数改变
        pageChange(page) {
            console.log('page页数改变', page)
            this.currentPage = page
            this.getListData(this.tableParam)
        },

        // 获取图表栏数据
        getChartData(param) {
            ajaxService.getHomeChart(param).then((res) => {
                console.log('图表栏数据', res)
                if (!res.ErrorCode) {
                    this.chartListData = res.Data
                }
            })
        },
        // 获取表格列表
        getListData(param) {
            ajaxService.getHomeList(param).then((res) => {
                console.log('表格列表', res)
                if (param.iExport) {
                    this.exportSet(res, '房企项目最新开工')
                } else {
                    if (!res.ErrorCode) {
                        this.tableObj.tableData = res.Data.aTakeHomeList.aList
                        this.total = Number(res.Data.aTakeHomeList.iTotal)
                        this.pageSize = res.Data.aTakeHomeList.iPageSize
                    }
                }
            })
        },
        // Echarts
        getOptions(echartType, obj) {
            switch (echartType) {
                case 'pie':
                    let pieoption = getCharts.getPieEchart(obj)
                    return pieoption
                    break
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj)
                    // console.log(baseoption)
                    return baseoption
                    break
                default:
                    break
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
